import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as playtimeApi from "../../../api/playtime";

/* ───────── Computers ───────── */

export function useComputers() {
  return useQuery({
    queryKey: ["computers"],
    queryFn: () => playtimeApi.fetchComputers(),
  });
}

/**
 * Fetches localized computer status options from the backend.
 * Returns `[{ value, name }]` entries suitable for select fields.
 */
export function useComputerStatuses() {
  return useQuery({
    queryKey: ["computers", "statuses"],
    queryFn: async () => {
      const map = await playtimeApi.fetchComputerStatuses();
      return Object.entries(map).map(([value, name]) => ({ value, name }));
    },
  });
}

export function useCreateComputer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => playtimeApi.createComputer(null, req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["computers"] });
    },
  });
}

export function useUpdateComputer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...req }) => playtimeApi.updateComputer(null, id, req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["computers"] });
    },
  });
}

export function useDeleteComputer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => playtimeApi.deleteComputer(null, id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["computers"] });
    },
  });
}
